document.addEventListener('DOMContentLoaded', function() {
  // Liquidから渡された全休日リストを取得
  const allHolidays = window.ShopifyAllHolidays || [];

  const calendarDaysContainer1 = document.getElementById('calendarDays1');
  const currentMonthYearHeader1 = document.getElementById('currentMonthYear1');
  const calendarDaysContainer2 = document.getElementById('calendarDays2');
  const currentMonthYearHeader2 = document.getElementById('currentMonthYear2');

  const mobilePrevMonthBtn = document.getElementById('mobilePrevMonth');
  const mobileNextMonthBtn = document.getElementById('mobileNextMonth');
  const mobileCurrentMonthYear = document.getElementById('mobileCurrentMonthYear');

  const currentMonthCalendar = document.getElementById('currentMonthCalendar');
  const nextMonthCalendar = document.getElementById('nextMonthCalendar');

  let currentDate = new Date();
  let displayMonth = currentDate.getMonth();
  let displayYear = currentDate.getFullYear();

  let activeCalendarIndex = 0; // 0: currentMonthCalendar, 1: nextMonthCalendar (スマホ用)

  // カレンダー描画関数
  function renderCalendar(targetMonth, targetYear, container, header) {
    container.innerHTML = '';
    const firstDayOfMonth = new Date(targetYear, targetMonth, 1);
    const lastDayOfMonth = new Date(targetYear, targetMonth + 1, 0);
    const numDaysInMonth = lastDayOfMonth.getDate();
    const firstDayOfWeek = firstDayOfMonth.getDay(); // 0 (日曜日) - 6 (土曜日)

    header.textContent = `${targetYear}年 ${targetMonth + 1}月`;

    // 前月の空白セル
    for (let i = 0; i < firstDayOfWeek; i++) {
      const emptyDiv = document.createElement('div');
      emptyDiv.classList.add('calendar-day', 'inactive');
      emptyDiv.textContent = ' '; 
      container.appendChild(emptyDiv);
    }

    // 今月の日付
    for (let day = 1; day <= numDaysInMonth; day++) {
      const dayDiv = document.createElement('div');
      dayDiv.classList.add('calendar-day');
      dayDiv.textContent = day;

      const fullDate = `${targetYear}-${String(targetMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const dayOfWeek = new Date(targetYear, targetMonth, day).getDay();

      // 土日判定
      if (dayOfWeek === 0 || dayOfWeek === 6) { // 日曜日 (0) または 土曜日 (6)
        dayDiv.classList.add('holiday');
      }

      // 祝日・任意休日判定 (allHolidaysを使用)
      if (allHolidays.includes(fullDate)) {
        dayDiv.classList.add('holiday');
      }

      // 今日かどうか
      if (day === currentDate.getDate() && targetMonth === currentDate.getMonth() && targetYear === currentDate.getFullYear()) {
        dayDiv.classList.add('today');
      }

      container.appendChild(dayDiv);
    }
  }

  // 全カレンダーの更新処理
  function updateAllCalendars() {
    // 当月のカレンダーを更新
    renderCalendar(displayMonth, displayYear, calendarDaysContainer1, currentMonthYearHeader1);

    // 次月のカレンダーを更新
    const nextMonthDate = new Date(displayYear, displayMonth + 1, 1);
    renderCalendar(nextMonthDate.getMonth(), nextMonthDate.getFullYear(), calendarDaysContainer2, currentMonthYearHeader2);

    // スマホ表示の更新
    updateMobileDisplay();
  }

  // スマホ表示の更新ロジック
  function updateMobileDisplay() {
    // CSSのブレイクポイントに合わせる（min-width: 750pxなので）
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile) {
      currentMonthCalendar.classList.remove('active');
      nextMonthCalendar.classList.remove('active');

      if (activeCalendarIndex === 0) {
        currentMonthCalendar.classList.add('active');
        mobileCurrentMonthYear.textContent = currentMonthYearHeader1.textContent;
      } else {
        nextMonthCalendar.classList.add('active');
        mobileCurrentMonthYear.textContent = currentMonthYearHeader2.textContent;
      }
    } else {
      // PC表示の時は両方表示 (CSSで制御)
      currentMonthCalendar.classList.add('active');
      nextMonthCalendar.classList.add('active');
    }
  }

  // PCでのリサイズ時にスマホ表示を更新
  window.addEventListener('resize', updateMobileDisplay);

  // 月切り替えボタンのイベントリスナー（スマホ用）
  mobilePrevMonthBtn.addEventListener('click', () => {
    if (activeCalendarIndex === 0) {
      displayMonth--;
      if (displayMonth < 0) {
        displayMonth = 11;
        displayYear--;
      }
      updateAllCalendars();
    }
    activeCalendarIndex = 0; // 常に当月に戻る
    updateMobileDisplay();
  });

  mobileNextMonthBtn.addEventListener('click', () => {
    if (activeCalendarIndex === 1) {
      displayMonth++;
      if (displayMonth > 11) {
        displayMonth = 0;
        displayYear++;
      }
      updateAllCalendars();
    }
    activeCalendarIndex = 1; // 常に次月へ進む
    updateMobileDisplay();
  });

  // 初期表示
  updateAllCalendars();
});